import { CSSObject } from "@emotion/react";

import { titleInputStyles } from "./SectionInput.style";

interface SectionInputProps {
  align: "left" | "right" | "center";
  placeholder: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  styleOverrides?: CSSObject;
}

const SectionInput = ({
  align,
  placeholder,
  value,
  onChange,
  styleOverrides,
}: SectionInputProps) => {
  const name = placeholder.toLowerCase().replaceAll(" ", "-");
  const qaSelector = `exportables-frayer-${name}-input`;
  const styles = { ...titleInputStyles(align), ...styleOverrides };

  return (
    <input
      id={`section-input-${name}`}
      type="text"
      data-qa-selector={qaSelector}
      css={styles}
      value={value}
      placeholder={placeholder}
      aria-label={placeholder}
      maxLength={25}
      onChange={onChange}
    />
  );
};

export default SectionInput;
